import React from 'react';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { renderRichText as renderRichTextFn } from 'gatsby-source-contentful/rich-text';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import * as themeStyles from '../assets/theme.module.scss';

const Bold = ({ children }) => <b>{children}</b>;
const Text = ({ children }) => <p>{children}</p>;

const options = {
    renderMark: {
        [MARKS.BOLD]: (text) => <Bold>{text}</Bold>,
    },
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
        [BLOCKS.HEADING_5]: (node, children) => <p className={themeStyles.textPrimary}>{children}</p>,
        [BLOCKS.HEADING_6]: (node, children) => <p className={themeStyles.textDanger}>{children}</p>,
        [BLOCKS.EMBEDDED_ENTRY]: (node) => (
            <>
                <h2>Embedded entry</h2>
                <pre>
                    <code>{JSON.stringify(node, null, 2)}</code>
                </pre>
            </>
        ),
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
            const { description } = node.data.target;
            return (
                <GatsbyImage
                    image={getImage(node.data.target)}
                    alt={description}
                    style={{ width: '70%', margin: '0 auto' }}
                />
            );
        },
    },
};

export const renderRichText = (content) => renderRichTextFn(content, options);

export const getDocumentPlanExcerpt = (document) => {
    const text = documentToPlainTextString(JSON.parse(document));
    return `${text.substring(0, 100)}...`;
};
